import React from "react";
import { TouchableOpacity } from "react-native";
import styled from "styled-components/native";
import { Spacer, VDBText } from "..";
import { SpaceType } from "../Spacer/types";
import { useTheme } from "styled-components/native";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  setCoachOverlayToast,
  setOverlayInactiveWeb,
} from "@redux/slices/appStateSlice";
import { useSelector } from "react-redux";
import { showToast, ToastTypes } from "@components/molecules/VDBToast/util";
import { useOverlayConfigWeb } from "@redux/slices/globalSlice";
import { OverlayConfig } from "./utils";
import { useIsFoldable } from "@navigations/utils/FoldableWrapper";
import { DefaultTheme } from "styled-components/native";

const JoyRideTooltip = ({
  setStepIndex,
  ...props
}: {
  setStepIndex: (index: number) => void;
  closeProps: any;
  index: number;
  step: any;
  isLastStep: boolean;
  size: number;
  handleTourEnd: () => void;
}) => {
  const { closeProps, index, step, isLastStep, size, handleTourEnd } = props;
  const toastVisibilityTime = useSelector(
    (state: any) => state.appState?.toastVisibilityTime
  );
  const theme = useTheme();
  const typography = useTypographyStore();
  const { t } = useTranslation();
  const { deviceWidth: screenWidth } = useIsFoldable();
  const dispatch = useDispatch();
  const overlayConfigWeb = useOverlayConfigWeb();
  const steps = OverlayConfig(overlayConfigWeb?.screens);
  const currentStep = step;
  const screenName = Object?.keys(steps)?.find((screen: string) =>
    (steps as Record<string, any>)?.[screen].steps?.some((current: any) => {
      const currentTarget = currentStep?.target
        ?.replace("#", "")
        .split("-")
        .pop();
      const stepTarget = current.target.split("-").pop();
      return stepTarget === currentTarget;
    })
  );

  const handleAction = () => {
    dispatch(setOverlayInactiveWeb({ screen: screenName }));
    if (toastVisibilityTime) {
      dispatch(setCoachOverlayToast(false));
      showToast(
        undefined,
        t("coachOverlay.toast.description.text"),
        ToastTypes.SUCCESS,
        true,
        true,
        undefined,
        undefined,
        true,
        Number(overlayConfigWeb?.toastVisibilityTime) || 5000
      );
    }
  };

  const handleOverlayAction = (e: any) => {
    if (screenName) {
      handleTourEnd();
      closeProps.onClick(e);
      handleAction();
    }
  };

  return (
    <TooltipContainer screenWidth={screenWidth}>
      <VDBText color={theme["core-05"]} type={typography["Body-R"]}>
        {t(step.content)}
      </VDBText>
      <Spacer size={SpaceType.Basic} />
      <ButtonContainer>
        <OverLayContainer>
          <StepContainer>
            <VDBText color={theme["core-05"]} type={typography["Body-M"]}>
              {`${index + 1}/${size}`}
            </VDBText>
          </StepContainer>
        </OverLayContainer>

        <OverLayContainer>
          {index !== 0 && index !== size && (
            <TouchableOpacity
              id="tooltip__button"
              onPress={() => setStepIndex(index - 1)}
            >
              <TextContainer>
                <VDBText
                  color={theme["link-static"]}
                  type={typography["Body-M"]}
                >
                  {t("coachOverlayWeb.tooltip.previous.text")}
                </VDBText>
              </TextContainer>
            </TouchableOpacity>
          )}

          <Spacer size={SpaceType.Basic} />
          {index + 1 !== size && (
            <TouchableOpacity
              id="tooltip__button tooltip__button--primary"
              onPress={() => setStepIndex(index + 1)}
            >
              <TextContainer>
                <VDBText
                  color={theme["link-static"]}
                  type={typography["Body-M"]}
                >
                  {t("coachOverlayWeb.tooltip.next.text")}
                </VDBText>
              </TextContainer>
            </TouchableOpacity>
          )}

          {isLastStep && (
            <TouchableOpacity
              id="tooltip__button tooltip__button--primary"
              onPress={(e) => handleOverlayAction(e)}
            >
              <TextContainer>
                <VDBText
                  color={theme["link-static"]}
                  type={typography["Body-M"]}
                >
                  {t("coachOverlayWeb.tooltip.finish.text")}
                </VDBText>
              </TextContainer>
            </TouchableOpacity>
          )}
        </OverLayContainer>
      </ButtonContainer>
    </TooltipContainer>
  );
};

const TooltipContainer = styled.View<any>`
  padding: ${SpaceType.Double}px;
  border-radius: ${SpaceType.Basic}px;
  background-color: ${({ theme }: { theme: DefaultTheme }) => theme["core-01"]};
`;

const OverLayContainer = styled.View`
  flex-direction: row;
`;

const ButtonContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const TextContainer = styled.View`
  padding: ${SpaceType.Basic}px;
`;

const StepContainer = styled.View`
  padding-top: ${SpaceType.Basic}px;
  padding-bottom: ${SpaceType.Basic}px;
  padding-right: ${SpaceType.Basic}px;
`;

export default JoyRideTooltip;
